<template>
      <div :class="{pages: !inline, 'pages-inline': inline}" v-if="pages>1">
        <a href="" class="first" :class="{disabled: modelValue==0}" @click.prevent="openPage('first')">
          <i class="fa-solid fa-angles-left"></i><span>First</span>
        </a>
        <a href="" class="prev" :class="{disabled: modelValue==0}" @click.prevent="openPage('prev')">
          <i class="fa-solid fa-angle-left"></i><span>Previous</span>
        </a>
        <a href="" class="next" :class="{disabled: modelValue==pages-1}" @click.prevent="openPage('next')">
          <i class="fa-solid fa-angle-right"></i><span>Next</span>
        </a>
        <a href="" class="last" :class="{disabled: modelValue==pages-1}" @click.prevent="openPage('last')">
          <i class="fa-solid fa-angles-right"></i><span>Last</span>
        </a>
        <div class="pagelist">
          <ul>
            <li v-for="page in pageList" :class="{active: page==modelValue}">
              <a href="" @click.prevent="openPage(page)">{{ page+1 }}</a>
            </li>
          </ul>
        </div>
      </div>
</template>

<script>
export default {
  props: {
    modelValue: {},
    pages: {},
    inline: {type: Boolean}
  },
  data: ()=>({
  }),
  computed: {
    pageList() {
      var result=[];
      for(var i=0;i<(this.pages || 1);i++) {
        if (i==this.pages-1 || i==0 || i%10==9 || Math.abs(i-this.modelValue)<5)
          result.push(i);
      }
      return result;
    },
  },
  methods: {
    openPage(page) {
      if (page=="first")
        this.$emit("update:modelValue", 0);
      else if (page=="prev")
        this.$emit("update:modelValue", Math.max(0, this.modelValue*1-1));
      else if (page=="next")
        this.$emit("update:modelValue", Math.min(Math.max(0, this.pages*1-1), this.modelValue*1+1));
      else if (page=="last")
        this.$emit("update:modelValue", Math.max(0, this.pages*1-1));
      else if (!isNaN(page*1))
        this.$emit("update:modelValue", page*1);
    },
  },
}
</script>
